import React, { Component } from 'react';
import './ImageEditor.css'
import Settings from './Settings'

  class ImageEditor extends Component{
    
    constructor(props){
      super(props)
      this.state={
      }
    }

    componentDidMount(){
   
    }
    saveSettings=(msg)=>{
      console.log("ImageEditor saveSettings")
      console.log(msg)
      this.props.getImage(msg)
    }

    render(){
      //console.log("ImageEditor render")
      return(
        <div className="settings">
          <Settings loadImage={this.props.loadImage} loadImageContainerSize={this.props.loadImageContainerSize}  saveSettings={this.saveSettings} editImageSize={this.props.editImageSize}/>  
        </div>
      )
    }
  }
  
  export default ImageEditor